const Modal = require('app/ui/Modal');

const RestaurantSupplierAssociationForm = require('app/restaurant/supplier/AssociationForm');

class AssociationModal {

    defaultOptions() {
        return {
            'id': window.uniqid(),
            'restaurant': null,
            'supplier': null,
            'success': function(event){},
            'onClose': function(event){},
            'onShown': function(event){},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.restaurant = this.settings.restaurant;
        if(!this.restaurant.id){
            window.notify("Missing restaurant object in SupplierAssociationModal","danger");
        }
        this.supplier = this.settings.supplier;
        if(!this.supplier.id){
            window.notify("Missing supplier object in SupplierAssociationModal","danger");
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.title = window.translate('app.restaurant.show.tabs.supplier.modal.title',{'%supplierName%':this.supplier.name});
        this.subtitle= window.translate('app.restaurant.show.tabs.supplier.association.title');

        this.build();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('restaurant-supplier-association-modal');

        this.modal = new Modal({
            'id': this.settings.id,
            'title': this.title,
            'subtitle': this.subtitle,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "xl",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,
        })

        this.buildForm();

        this.modal.show();
    }

    buildForm(){
    	this.form = new RestaurantSupplierAssociationForm({
    		'restaurant': this.restaurant,
    		'supplier': this.supplier,
    		'success': this.settings.success
    	});

    	this.$content.append(this.form.getForm());
    }
    
    hasChange(){
        return this.form ? this.form.hasChange() : false;
    }

    hide(){
        this.modal.hide();
    }

    show(){
        this.modal.show();
    }

    dispose(){
        this.modal.dispose();
    }
}

module.exports = AssociationModal;

